<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="الإهـداء">
<h1><span dir="rtl">الإهـداء</span></h1>
<p style="text-indent:0em !important"><span dir="rtl">إلى أبي الذي لطالما تمنَّى أن تخرج إحدى كتاباته إلى النور.</span></p><br/>
<p style="text-indent:0em"><span dir="rtl">أرجو أن تَقبل هذا الكتاب هديَّة مِن ابنتكَ التي ورثَت عشقك للقراءة والكتابة</span>.</p><br/>
<p style="text-indent:0em !important"><span dir="rtl">وإليكَ أنتَ، يا مَن إذا قرأتَ هذه السطور علمتَ أنَّك سبب خطِّها ورصفها منذ البداية.</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch003.vue?c71e3ad2